import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./vendordata.css";
import { CSVLink } from "react-csv";
import { Player } from "@lottiefiles/react-lottie-player";

function Vendorlist() {
  const [vendors, setVendors] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});

  useEffect(() => {
    fetchVendors();
  }, []);

  const fetchVendors = async () => {
    try {
      const response = await axios.get(
        `${INVENTORY_API_BASE_URL}/get-vendors`
      );
      setVendors(response.data);
    } catch (error) {
      console.error("Failed to fetch vendors:", error);
    }
  };

  const handleEditClick = (vendor) => {
    setEditingId(vendor._id);
    setEditedData({ ...vendor });
  };

  const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    const capitalizeFields = [
      "name",
      "contactPerson",
      "category",
      "address",
      "productsOrServices",
    ];

    if (capitalizeFields.includes(name)) {
      updatedValue = capitalizeWords(updatedValue);
    }

    setEditedData({ ...editedData, [name]: updatedValue });
  };

  const handleSave = async () => {
    try {
      await axios.put(
        `${INVENTORY_API_BASE_URL}/update-vendor/${editingId}`,
        editedData
      );
      setEditingId(null);
      fetchVendors();
    } catch (error) {
      console.error("Failed to update vendor:", error);
      alert("Update failed!");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this vendor?")) return;
    try {
      await axios.delete(
        `${INVENTORY_API_BASE_URL}/delete-vendor/${id}`
      );
      fetchVendors();
    } catch (error) {
      console.error("Failed to delete vendor:", error);
      alert("Delete failed!");
    }
  };

  const csvHeaders = [
    { label: "Created Date", key: "createdAt" },
    { label: "Vendor Name", key: "name" },
    { label: "Contact Person", key: "contactPerson" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "phone" },
    { label: "Vendor Category", key: "category" },
    { label: "GST", key: "gst" },
    { label: "Bank A/C", key: "acc" },
    { label: "IFSC", key: "ifsc" },
    { label: "Address", key: "address" },
    { label: "Products / Services", key: "productsOrServices" },
    { label: "Pancard", key: "pan" },
    { label: "Hsn Number", key: "hsn" },
  ];

  return (
    <div className="vendorlist-container">
      <div style={{ marginBottom: "10px" }}>
        <CSVLink
          data={vendors}
          headers={csvHeaders}
          filename={"vendors-list.csv"}
          className="btn btn-primary"
          target="_blank"
        >
          Download CSV
        </CSVLink>
      </div>

      {vendors.length === 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "40px",
            color: "#6c757d",
            fontFamily: "Segoe UI, sans-serif",
          }}
        >
          <Player
            autoplay
            loop
            src="https://assets10.lottiefiles.com/packages/lf20_qp1q7mct.json"
            style={{ height: "220px", width: "220px" }}
          />
          <p style={{ fontSize: "18px", fontWeight: "600", marginTop: "10px" }}>
            No vendor data found
          </p>
        </div>
      ) : (
        <div className="table-scroll-wrapper">
          <table>
            <thead>
              <tr>
                <th>Created Date</th>
                <th>Vendor Name</th>
                <th>Contact Person</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Vendor Category</th>
                <th>GST</th>
                <th>Bank A/C</th>
                <th>IFSC</th>
                <th>Pan Card</th>
                <th>HSN Number</th>
                <th>Address</th>
                <th>Products / Services</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {vendors.map((vendor) => (
                <tr key={vendor._id}>
                  <td>{new Date(vendor.createdAt).toLocaleDateString()}</td>
                  {editingId === vendor._id ? (
                    <>
                      <td>
                        <input
                          name="name"
                          value={editedData.name}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="contactPerson"
                          value={editedData.contactPerson}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="email"
                          value={editedData.email}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="phone"
                          value={editedData.phone}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="category"
                          value={editedData.category}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="gst"
                          value={editedData.gst}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="acc"
                          value={editedData.acc}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="ifsc"
                          value={editedData.ifsc}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="pan"
                          value={editedData.pan}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="hsn"
                          value={editedData.hsn}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="address"
                          value={editedData.address}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          name="productsOrServices"
                          value={editedData.productsOrServices}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <button onClick={handleSave}>Save</button>
                      </td>
                      <td>
                        <button disabled>Delete</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{vendor.name}</td>
                      <td>{vendor.contactPerson}</td>
                      <td>{vendor.email}</td>
                      <td>{vendor.phone}</td>
                      <td>{vendor.category}</td>
                      <td>{vendor.gst}</td>
                      <td>{vendor.acc}</td>
                      <td>{vendor.ifsc}</td>
                      <td>{vendor.pan}</td>
                      <td>{vendor.hsn}</td>
                      <td>{vendor.address}</td>
                      <td>{vendor.productsOrServices}</td>
                      <td>
                        <button onClick={() => handleEditClick(vendor)}>
                          Edit
                        </button>
                      </td>
                      <td>
                        <button onClick={() => handleDelete(vendor._id)}>
                          Delete
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Vendorlist;
